import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import _ from "lodash";
import Title from "../../components/Layout/Title";

import MaskDate from "../../components/Util/MaskDate";
import { DOCUMENTO_ASSINADO_LOAD, DOCUMENTO_ASSINADO_UNLOAD } from "../../actions/Constants";

import api from "../../api/apiUtil";
import ReactTable from "react-table";

class DocumentoAssinado extends React.Component {
  componentDidMount() {
    this.props.onListLoad(api.Configuracao.getDocumentosAssinados());
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Imagens com e sem assinatura" />
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="hpanel">
                      <div className="panel-heading">Imagens Analisadas</div>
                      <div className="panel-body">
                        <div className="table-responsive">
                          <ReactTable
                            className="-striped -highlight"
                            defaultPageSize={20}
                            data={this.props.all}
                            loadingText="Carregando..."
                            noDataText="Nenhum Registro encontrado"
                            rowsText="linhas"
                            showPageSizeOptions={false}
                            minRows={1}
                            showPagination={true}
                            previousText="Anterior"
                            nextText="Próximo"
                            pageText="página"
                            ofText="de"
                            columns={[
                              {
                                Header: "UF",
                                accessor: "uf",
                                headerClassName: "font-extra-bold",
                                width: 40,
                              },
                              {
                                Header: "Financeira",
                                accessor: "razaoSocial",
                                headerClassName: "font-extra-bold",
                              },
                              {
                                Header: "Nr Contrato",
                                accessor: "numero",
                                className: "align-middle text-center",
                                headerClassName: "font-extra-bold",
                              },
                              {
                                Header: "Chassi",
                                accessor: "chassi",
                                className: "align-middle text-center",
                                headerClassName: "font-extra-bold",
                                width: 160,
                              },
                              {
                                Header: "Nome",
                                accessor: "nome",
                                className: "align-middle text-center",
                                headerClassName: "font-extra-bold",
                                width: 160,
                              },
                              {
                                Header: "Data",
                                accessor: "rowData",
                                className: "align-middle text-center",
                                headerClassName: "font-extra-bold",
                                width: 140,
                                Cell: (rowData) => {
                                  return (
                                    <div>
                                      <span>{MaskDate.TO_BR_DATETIME(rowData.original.data)}</span>
                                      <br />
                                    </div>
                                  );
                                },
                              },
                              {
                                Header: "Assinado",
                                accessor: "rowSigned",
                                className: "align-middle text-center",
                                headerClassName: "font-extra-bold",
                                width: 90,
                                Cell: (rowSigned) => {
                                  return (
                                    <div>
                                      <span>{rowSigned.original.isSigned ? "Sim" : "Não"}</span>
                                      <br />
                                    </div>
                                  );
                                },
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onListLoad: (payload) => dispatch({ type: DOCUMENTO_ASSINADO_LOAD, payload }),
  onUnload: (payload) => dispatch({ type: DOCUMENTO_ASSINADO_UNLOAD, payload }),
});

const mapStateToProps = (state) => ({
  ...state.documentoAssinado,
});

const form = reduxForm({
  form: "DocumentoAssinadoForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(DocumentoAssinado));
